<template>
  <div class="all">
    <div class="nav-pc">
      <div class="title">
        <img src="@/static/img/xlhd_edge_icon.svg" />
        系列活动
      </div>
    </div>
    <div class="center-pc">
        <div>
            <div v-for="(item, index) in activityList" :key="index" class="list-item" :style="{'background-color': index%2 == 0 ? 'rgb(249 242 229)' : 'rgb(255 252 245)' }">
                <img class="item-l" src="@/static/img/xlhd_icon.svg" />
                <div class="item-center">
                    <p>
                        <label class="label-item"><span>名称</span>{{ item.title }}</label>
                        <label class="label-item"><span>地点</span>{{ item.address }}</label>
                        <label class="label-item"><span>活动规模</span>{{ item.activityScale }}人</label>
                    </p>
                    <p>
                        <label class="label-item"><span>时间</span>{{ item.startTime | timeFilter }}&emsp;--&emsp;{{ item.endTime | timeFilter  }}</label>
                    </p>
                    <p>
                        <label class="label-item"><span>主办单位</span>{{ item.activityOrganizer }}</label>
                    </p>
                </div>
                <div class="item-r">
                    <span @click="toDetail(item)">查看详情</span>
                    <span v-if="item.isEnroll == 1" @click="cancelSign(item)">取消报名</span>
                </div>
            </div>
        </div>
    </div>
    
    <el-pagination class="set-el-pager" layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>

    <div class="foo-pc">
        <button class="leftBtn" @click="goBack">返回</button>
    </div>
  </div>
</template>

<script>
import { sessionData } from "@/static/js/local.js"
import { invitedGuestActivities, normalGuestActivities, cancelEnroll } from "@/api/series"
var that

export default {
    data() {
        return {
            mainId: '',
            total: 50,
            activityList: []
        }
    },
    filters: {
        timeFilter: function(tsp) {
            try {
                if (!tsp || tsp.toString().length == 0) {
                return ''
                }

                return that.$parseTime(tsp, '{y}-{m}-{d} {h}:{i}')
            } catch (err) {
                return ''
            }
        }
    },
    beforeCreate() {
        that = this
    },
    created() {
        this.mainId = this.$session.get("cmm").mainId
        this.getList(1)
    },
    watch: {

    },
    methods: {
        getList(pageNum) {
            var fuc = this.$cookies.get("regType") == 2 ? invitedGuestActivities : normalGuestActivities
            fuc({
                mainId: this.mainId,
                page: {
                    pageNum: pageNum,
                    pageSize: 10
                }
            }).then(res => {
                if(res.code == 200) {
                    this.total = res.data.count
                    this.activityList = res.data.result
                    sessionData("set", "activityList", this.activityList)
                }
            })
        },
        toDetail(row) {
            this.$router.push(`/series/detail/${row.id}`)
        },
        cancelSign(row) {
            this.$msgbox({
                title: "确认信息",
                message: "确认取消报名该活动？",
                showClose: false,
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                cancelButtonClass: "cancel-btn-color",
                confirmButtonClass: "btn-color",
                callback: (action, instance) => {
                    if (action == "confirm") {
                        cancelEnroll(row.activityRegistrationId).then(res => {
                            if(res.code == 200) {
                                this.$message({
                                    message: '成功取消报名',
                                    type: 'success'
                                })
                                setTimeout(() => {
                                    this.getList(1)
                                }, 1000)
                            }
                        })
                    }
                }
            });
        },
        goBack() {
            this.$router.push('/')
        },
        handleCurrentChange(val) {
            this.getList(val)
        }
    }
};
</script>

<style src="../../../static/css/regist.css" scoped></style>
<style src="../../../static/css/infoCommon.css" scoped></style>
<style scoped>
.center-pc {
    font-size: 20px;
    color: #C1A17B;
}
.type-nav {
    height: 35px;
    line-height: 35px;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
}
.type-nav li {
    width: 110px;
    margin: 0 20px;
    text-align: center;
    font-family: "sourcehans-CN";
    cursor: pointer;
}
.type-nav .active {
    color: #fff;
    background: #C1A17B;
}
.list-item {
    height: 150px;
    margin-top: 15px;
    display: flex;
    align-items: center;
}
.list-item .item-l {
    width: 50px;
    margin: 0 25px;
}
.list-item .item-center {
    width: 70%;
    font-size: 18px;
    line-height: 35px;
}
.list-item .item-center p:first-child .label-item {
    width: 33.3%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
}
.list-item .item-center .label-item  span {
    margin-right: 30px;
}
.list-item .item-r span {
    padding: 5px 15px;
    cursor: pointer;
}
.list-item .item-r span:not(:last-child) {
    border-right: 2px solid #C1A17B;
}
.list-item span {
    font-family: "sourcehans-CN";
}
</style>
